(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hol-quantity-offers"] && !Shopify.designMode) return;
  try {
    class HolQuantityOffers extends HTMLElement {
  static query = `mutation QuantityOfferQuote($variantId: ID!, $country: CountryCode!) {
  one: cartCreate(input: {buyerIdentity: {countryCode: $country}, lines: [{merchandiseId: $variantId, quantity: 1}]}) { ...OfferQuote }
  two: cartCreate(input: {buyerIdentity: {countryCode: $country}, lines: [{merchandiseId: $variantId, quantity: 2}]}) { ...OfferQuote }
  four: cartCreate(input: {buyerIdentity: {countryCode: $country}, lines: [{merchandiseId: $variantId, quantity: 4}]}) { ...OfferQuote }
}
fragment OfferQuote on CartCreatePayload {
  userErrors { code message }
  warnings { code }
  cart { lines(first: 2) { nodes { quantity merchandise { ... on ProductVariant { id } } cost { amountPerQuantity { amount currencyCode } totalAmount { amount currencyCode } } discountAllocations { __typename discountedAmount { amount currencyCode } ... on CartAutomaticDiscountAllocation { title } } } pageInfo { hasNextPage } } }
}
`;

  static parseQuote(payload, quantity, variantId, currency, basePrice) {
    if (!payload || payload.userErrors?.length || payload.warnings?.length) return null;
    const lines = payload.cart?.lines;
    if (lines?.pageInfo?.hasNextPage || lines?.nodes?.length !== 1) return null;
    const line = lines.nodes[0];
    if (line.quantity !== quantity || line.merchandise?.id !== variantId) return null;
    const money = (value) => {
      if (value?.currencyCode !== currency || !/^\d+(\.\d{1,2})?$/.test(value.amount)) return NaN;
      return Math.round(Number(value.amount) * 100);
    };
    const base = money(line.cost?.amountPerQuantity);
    const total = money(line.cost?.totalAmount);
    if (base !== basePrice || !Number.isSafeInteger(total) || total < 0 || total > base * quantity) return null;
    const allocations = line.discountAllocations || [];
    if (allocations.some((allocation) => allocation.__typename !== 'CartAutomaticDiscountAllocation')) return null;
    const discount = allocations.reduce((sum, allocation) => sum + money(allocation.discountedAmount), 0);
    if (!Number.isSafeInteger(discount) || discount < 0 || base * quantity - discount !== total) return null;
    if (total % quantity !== 0) return null;
    return { quantity, unitPrice: total / quantity, automaticSaving: discount / quantity };
  }

  connectedCallback() {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    this.form = this.closest('form');
    this.selector = this.form?.querySelector('quantity-selector-component');
    this.quantityInput = this.selector?.querySelector('input[name="quantity"]');
    this.hidden = true;
    this.ready = false;
    if (!this.quantityInput) return;
    customElements.whenDefined('quantity-selector-component').then(() => {
      if (!this.isConnected || signal.aborted) return;
      this.addEventListener('change', this.selectOffer, { signal });
      this.form.addEventListener('quantity-selector:update', this.syncOffers, { signal });
      this.quantityInput.addEventListener('input', this.syncOffers, { signal });
      this.quantityInput.addEventListener('change', this.syncOffers, { signal });
      this.closest('.shopify-section')?.addEventListener('shopify:product:select', this.onVariantChange, { signal });
      document.addEventListener('visibilitychange', this.onVisible, { signal });
      window.addEventListener('pageshow', this.onVisible, { signal });
      this.observer = new MutationObserver(this.syncOffers);
      this.observer.observe(this.quantityInput, { attributes: true, attributeFilter: ['max', 'min', 'step', 'disabled', 'data-cart-quantity'] });
      this.refresh();
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.requestController?.abort();
    this.observer?.disconnect();
    clearTimeout(this.expiryTimer);
    this.generation = (this.generation || 0) + 1;
  }

  onVariantChange = (event) => {
    const sourceCard = event.target?.closest?.('product-card');
    if (sourceCard && !sourceCard.contains(this)) return;
    this.variantChanging = true;
    this.ready = false;
    this.hidden = true;
    this.dataset.status = 'variant-changing';
    this.requestController?.abort();
    clearTimeout(this.expiryTimer);
    this.generation = (this.generation || 0) + 1;
  };

  onVisible = () => {
    if (document.visibilityState === 'visible' && Date.now() - (this.checkedAt || 0) > 60000) this.refresh();
  };

  async refresh() {
    if (!this.isConnected || this.variantChanging || this.loading) return;
    this.hidden = true;
    this.ready = false;
    this.dataset.status = 'checking';
    clearTimeout(this.expiryTimer);
    const variantId = `gid://shopify/ProductVariant/${this.dataset.variantId}`;
    if (this.dataset.available !== 'true' || Number(this.quantityInput.min || 1) !== 1 || this.form.querySelector('[name="selling_plan"]')?.value) {
      this.dataset.status = 'unavailable';
      return;
    }
    const generation = this.generation = (this.generation || 0) + 1;
    this.loading = true;
    this.requestController = new AbortController();
    const timeout = setTimeout(() => this.requestController?.abort(), 12000);
    try {
      const response = await fetch('/api/2026-07/graphql.json', {
        method: 'POST',
        credentials: 'omit',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        signal: this.requestController.signal,
        body: JSON.stringify({ query: HolQuantityOffers.query, variables: { variantId, country: this.dataset.country } }),
      });
      if (!response.ok) throw new Error('Quantity offer quote unavailable');
      const result = await response.json();
      if (result.errors?.length) throw new Error('Quantity offer quote rejected');
      if (!this.isConnected || generation !== this.generation || this.form.querySelector('[name="id"]')?.value !== this.dataset.variantId) return;
      const basePrice = Number(this.dataset.price);
      const quotes = [1, 2, 4].map((quantity, index) => HolQuantityOffers.parseQuote(result.data?.[['one', 'two', 'four'][index]], quantity, variantId, this.dataset.currency, basePrice));
      this.checkedAt = Date.now();
      const [single] = quotes;
      if (!single || !quotes.some((quote) => quote?.quantity > 1 && quote.automaticSaving > single.automaticSaving && quote.unitPrice < single.unitPrice)) {
        this.dataset.status = 'no-promotion';
        return;
      }
      const reference = Math.max(Number(this.dataset.referencePrice), basePrice);
      const format = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: this.dataset.currency });
      this.querySelectorAll('input[type="radio"]').forEach((radio, index) => {
        const quote = quotes[index];
        const option = radio.closest('label');
        option.hidden = !quote;
        radio.dataset.quoted = quote ? 'true' : 'false';
        if (!quote) return;
        const price = format.format(quote.unitPrice / 100);
        const saving = format.format(Math.max(0, reference - quote.unitPrice) / 100);
        const regular = format.format(reference / 100);
        option.querySelector('.hol-offers__prices strong').textContent = price;
        const compare = option.querySelector('.hol-offers__prices s');
        compare.textContent = regular;
        compare.hidden = reference <= quote.unitPrice;
        const savingElement = option.querySelector('.hol-offers__saving');
        savingElement.textContent = savingElement.dataset.template.replace('__amount__', saving);
        savingElement.hidden = reference <= quote.unitPrice;
        radio.setAttribute('aria-label', radio.dataset.label.replace('__price__', price).replace('__amount__', saving).replace('__reference__', regular));
      });
      this.style.setProperty('--hol-offer-count', quotes.filter(Boolean).length);
      this.ready = true;
      this.syncOffers();
      this.dataset.status = 'ready';
      this.hidden = false;
    } catch {
      if (generation === this.generation) this.dataset.status = 'error';
    } finally {
      clearTimeout(timeout);
      this.loading = false;
      if (this.isConnected && generation === this.generation) {
        this.expiryTimer = setTimeout(() => {
          this.ready = false;
          this.hidden = true;
          this.dataset.status = 'stale';
          if (document.visibilityState === 'visible') this.refresh();
        }, 300000);
      }
    }
  }

  selectOffer = async (event) => {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement) || radio.type !== 'radio' || radio.disabled) return;
    if (Date.now() - (this.checkedAt || 0) > 60000) await this.refresh();
    if (!this.ready || radio.disabled || !this.isConnected) return;
    this.selector.setValue(radio.value);
    this.selector.updateButtonStates();
    this.selector.onQuantityChange();
    this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  syncOffers = () => {
    const quantity = Number(this.quantityInput.value);
    const min = Number(this.quantityInput.min) || 1;
    const step = Number(this.quantityInput.step) || 1;
    const max = this.selector.getEffectiveMax();
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      const value = Number(radio.value);
      radio.disabled = !this.ready || radio.dataset.quoted !== 'true' || this.quantityInput.disabled || value < min || (value - min) % step !== 0 || (max !== null && value > max);
      radio.checked = !radio.disabled && value === quantity;
    });
  };
}
if (!customElements.get('hol-quantity-offers')) customElements.define('hol-quantity-offers', HolQuantityOffers);
  } catch(e) { console.error(e); }
})();

})();
